import { FunctionComponent } from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import PetImage from './PetImage';
import PetDescription from './PetDescription';
import Pet from '@spike/pet-model';
import clsx from 'clsx';

interface PetCardProps {
    pet?: Pet;
    onShowPetCard?: () => void;
    className?: string;
    imageClassName?: string;
    petDescriptionClassName?: string;
    petSizeClassName?: string;
    petItemLabelClassName?: string;
    showWeight?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex'
        },
        image: {
            width: 64,
            height: 64,
            marginRight: 18,
            [theme.breakpoints.up('md')]: {
                marginRight: 20
            }
        },
        petDescriptionContainer: {
            display: 'flex',
            width: '80%'
        }
    })
);

export const PetCard: FunctionComponent<PetCardProps> = props => {
    const classes = useStyles(props);

    return (
        <Box className={clsx(classes.container, props.className)}>
            <Box className={clsx(classes.image, props.imageClassName)}>
                <PetImage
                    petImage={props.pet?.image}
                    petType={props.pet?.type?.id}
                    imageClassName={props.imageClassName}
                />
            </Box>
            <Box className={clsx(classes.petDescriptionContainer, props.petDescriptionClassName)}>
                <PetDescription
                    pet={props.pet}
                    onShowPetCard={props.onShowPetCard}
                    petSizeClassName={props.petSizeClassName}
                    petItemLabelClassName={props.petItemLabelClassName}
                    showWeight={props.showWeight}
                />
            </Box>
        </Box>
    );
};

export default PetCard;
